<div
  class="gw-flex gw-min-h-0 gw-w-full gw-flex-1 gw-flex-col gw-gap-medium gw-text-small"
>
  <gatewee-input-v2
    [id]="'bank-slip-digitable'"
    [form]="form"
    controlName="digitableLine"
    type="text"
    [submitted]="submitted"
    [placeholder]="
      'features.withdrawals.modalBankSlip.digitablePlaceholder' | translate
    "
    [customMessages]="digitableCustomMessages"
    [hint]="{
      message: 'features.withdrawals.modalBankSlip.digitableHint',
      icon: '@phi.info'
    }"
    [label]="'features.withdrawals.modalBankSlip.digitableLabel' | translate"
  ></gatewee-input-v2>

  <button
    type="button"
    class="gw-mt-small gw-flex gw-w-full gw-items-center gw-justify-center gw-gap-small gw-rounded-xl gw-border gw-bg-background-elevation-2 gw-px-medium gw-py-medium gw-cursor-pointer hover:gw-bg-background-neutral-1-hover"
    (click)="scanRequested.emit()"
  >
    <gatewee-icon
      icon="@phi.barcode"
      size="22px"
      iconStyle="primary"
    ></gatewee-icon>
    <span class="gw-text-text-primary gw-text-[14px] gw-font-semibold">
      {{ 'features.withdrawals.modalBankSlip.scanCta' | translate }}
    </span>
  </button>
</div>
